<template>
  <a href="#" class="go_top_btn btn" @click.prevent="clickAction" @mouseenter="animBtn" @mouseleave="animBtnRev">
    <span class="overlay" :class="[backColor ? 'bg' : '']"></span>
    <chevronUp :width="40"/>
  </a>
</template>

<script>
import chevronUp from './svg_icons/chevronUp.vue';
export default {
  name: 'topButton',
  components: {
    chevronUp
  },
  props: {
    backColor:{
      type: Boolean,
      required: false,
      default: false
    }
  },
  methods: {
    clickAction() {
      if(this.$route.path != '/contact') this.$router.push({ path: '/' })
      let el = this.$el
      let scrollMinTime = Math.floor(el.offsetTop / 100) / 10
      let scrollTime = Math.max(scrollMinTime, 1)
      TweenLite.to(window, scrollTime, {scrollTo: {y: '0'}, ease: Power3.easeOut});
    },
    animBtn(e){
      if(e.target.querySelector('span.overlay')){ 
          let btnTweenForw = new TimelineLite()
          .to(e.target.querySelector('span.overlay'), 0.3, {css: { y: 0, force3D: true }, ease: Power2.easeOut}).to(e.target, 0.3, {css: { color: 'white' }, ease: Power0.easeOut},'-=0.3')
        }
    },
    animBtnRev(e){
      if(e.target.querySelector('span.overlay')){ 
        let btnTweenBackw = new TimelineLite()
          .to(e.target.querySelector('span.overlay'), 0.3, {css: { y: -60, force3D: true }, ease: Power2.easeOut}).to(e.target, 0.3, {css: { color: '#ced4da' }, ease: Power0.easeOut},'-=0.3')
      }
    }
  }
}
</script>

<style scoped lang="scss">
.go_top_btn{
  background-color: white;
  padding: 5px;
  color: $gray-400;
  position: relative;
  overflow: hidden;
}
.bg{
  background-color: $pink;
} 
</style>
